import { IN_SEASON } from '../../constants/mapLayerIds';

/**
 * Extracts the application layers from the seasonObject passed in
 * @param {Object} seasonObject
 * @return {Object}
 */
export function extractApplicationLayers(seasonObject) {

  if (seasonObject.liquidData) {
    const { crop, liquidEndDate } = seasonObject.liquidData[0];
    const activeApplication = `${liquidEndDate}_${crop}`;
    return {
      [IN_SEASON.APPLICATIONS]: {
        activeSubLayerIds: [activeApplication, activeApplication],
        subLayers: {},
      },
    };
  }
  return {};
}
